const getPostbackSettingsErrors = state => state.postbackSettings.errors;
export const getLoadPostbackSettingsError = state => (
  getPostbackSettingsErrors(state).loadPostbackSettingsError
);
export const getEditPostbackSettingsError = state => (
  getPostbackSettingsErrors(state).editPostbackSettingsError
);
export const getTestPostbackSettingsError = state => (
  getPostbackSettingsErrors(state).testPostbackSettingsError
);
